module.exports = __webpack_public_path__ + "static/img/about.a01bb99.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/banner/about.jpg
// module id = mbnw
// module chunks = 1